<template>
  <div class="client-logo-wrapper">
    <div
      class="client-logo"
      :style="`background-image: url('${logoUrl}');`"
    >
      &nbsp;
    </div>
  </div>
  <!-- <img
    :src="logoUrl"
    class="client-logo"
    :class="{
      large,
    }"
  /> -->
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    url: {
      type: [String, Object],
      required: false,
    },
    large: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    logoUrl() {
      return this.url || this.company.logo_url;
    },
  },
};
</script>

<style lang="scss" scoped>
.client-logo-wrapper {
  height: 65px;
  min-height: 65px;
  max-height: 65px;
  width: 65px;
  max-width: 65px;
  box-shadow: 2px 2px 12px 5px #dddddd;
  padding: 5px;
  .client-logo {
    width: 100%;
    height: 100%;
    background-size: contain;
    background-position: center;
  }
}
// .client-logo {
//   box-shadow: 2px 2px 12px 5px #dddddd;
//   max-width: 60px;
//   height: auto;
//   padding: 8px;
//   &.large {
//     min-height: 120px;
//     max-height: 120px;
//   }
// }
</style>
